<app-matter-form-viewer-container></app-matter-form-viewer-container>
<div
	*ngIf="showPlaceholder"
	class="forms-viewer-empty bg-grey-lightest flex justify-center"
>
	<div class="placeholder flex flex-col justify-center">
		<div class="empty-state-image">
			<img src="assets/images/empty-states/forms.svg" />
		</div>
		<p class="text-center">
			To view a form, please add a lender form from the list.
		</p>
	</div>
</div>
